import React from 'react'
import { useHistory } from 'react-router-dom'
import { Box, Grid, Typography } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'
import MergeRecordsTable from './components/MergeRecordsTable'
import MergeRecordsFilters from './components/MergeRecordsFilters'
import useEntityMergeRecords from './hooks/useEntityMergeRecords'
import { MERGE_TYPES } from './constants'

const PeopleMergeRecords = () => {
  const history = useHistory()

  const {
    records,
    pagination,
    itemCount,
    filters,
    isLoading,
    handlePageChange,
    handlePageSizeChange,
    handleTermChange,
    handleStatusChange,
  } = useEntityMergeRecords(MERGE_TYPES.PEOPLE)

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" sx={{ fontWeight: 'fontWeightBold' }}>
            Merge People Profile
          </Typography>
        </Grid>
        <Grid item>
          <Button variant="contained" onClick={() => history.push('/merge-profiles/people/new')}>
            Merge Profile
          </Button>
        </Grid>
      </Grid>

      <Grid item>
        <MergeRecordsFilters
          filters={filters}
          onTermChange={handleTermChange}
          onStatusChange={handleStatusChange}
        />
      </Grid>

      <Grid item>
        <Box sx={{ minHeight: 400 }}>
          <MergeRecordsTable
            records={records}
            isLoading={isLoading}
            pagination={pagination}
            itemCount={itemCount}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default PeopleMergeRecords
